import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { PlatformService } from '@big-direkt/utils/shared';
import { captureException } from '@sentry/browser';
import { EnvironmentService } from '../services/environment.service';
import { FeatureFlagsService } from '../services/feature-flags.service';

@Injectable({ providedIn: 'root' })
export class CustomErrorHandlerService extends ErrorHandler {
    private readonly environmentService = inject(EnvironmentService);
    private readonly featureFlagService = inject(FeatureFlagsService);
    private readonly platformService = inject(PlatformService);

    public override handleError(error: unknown): void {
        if (!this.featureFlagService.isFeatureEnabled('big-app-global-error-tracking')()) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized) {
            return;
        }

        // eslint-disable-next-line no-console
        console.error(error);

        this.logToSentry(error);
    }

    private logToSentry(error: unknown): void {
        if (this.environmentService.sentryDsn === undefined) {
            return;
        }

        captureException(error);
    }
}
